export default "__VITE_ASSET__C1wC41ej__"